goog.provide("shadow.js.shim.module$ol$source$Vector$default");
shadow.js.shim.module$ol$source$Vector$default = shadow.js.require(221, {}).default;
